// =============================================================================
//  Copyright : 2018 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : domain parts
// =============================================================================

// ---Third-party imports
import React from 'react'
import {Table} from 'semantic-ui-react'

// ---Framework imports
import {Actions, Sel} from 'uix/registries'
import {funcPart} from 'uix/parts'
import log from 'uix/logging'
import {mapItems, items, size, values, get} from 'ldash'
import {Link} from 'uix/components'
import {useSelector} from 'uix/hooks'
import {DomainIcon} from 'uix/domain/icon'
// ---Globals

export const TestDomains = funcPart({}, ({go, i18n}) => {
  let domains = useSelector(Sel.domains)

  let buildDomain = data => {
    if (data.isGhost) {
      return <span style={{paddingLeft: '0.3em', color: 'grey'}}>{data.description}</span>
    } else {
      return <Link dname={data.name}>{data.description}</Link>
    }
  }

  let rows = mapItems(domains.data, (k, v) => (
    <Table.Row key={k}>
      <Table.Cell>{v.id}</Table.Cell>
      <Table.Cell style={{paddingLeft: `${v.level}em`}}>
        <DomainIcon dname={v.name} />
        {buildDomain(v)}
      </Table.Cell>
      <Table.Cell>{k}</Table.Cell>
      <Table.Cell>{k != v.routingPrefix ? v.routingPrefix : ''}</Table.Cell>
      <Table.Cell>{i18n.getType('domain', v.type)}</Table.Cell>
    </Table.Row>
  ))

  return (
    <Table celled compact size="small" id="domains">
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>ID</Table.HeaderCell>
          <Table.HeaderCell>Description</Table.HeaderCell>
          <Table.HeaderCell>Name</Table.HeaderCell>
          <Table.HeaderCell>Routing</Table.HeaderCell>
          <Table.HeaderCell>Type</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>{rows}</Table.Body>
    </Table>
  )
})
